const getNewScreenFlow = (screens, newScreens) => {
  if (!Array.isArray(screens) || !Array.isArray(newScreens)) return screens;

  let newScreenFlow = screens;

  newScreens.forEach(newScreen => {
    const insertionIndex = newScreenFlow.findIndex(
      screen => screen === newScreen.prev_screen
    );

    if (insertionIndex > -1 && newScreen.screen_name !== undefined) {
      newScreenFlow.splice(insertionIndex + 1, 0, newScreen.screen_name);
    }
  });

  return newScreenFlow;
};

export { getNewScreenFlow };
